export enum UserReviewStatus {
  PENDING = 'PENDING',
  TO_REVIEW = 'TO_REVIEW',
  REVIEWED = 'REVIEWED',
  IGNORED = 'IGNORED'
}